import { useEffect } from 'react';

const landingFrameStyle = {
  width: '100vw',
  height: '100dvh',
  border: 0,
  display: 'block',
  background: '#080809',
};

const pageStyle = {
  width: '100vw',
  minHeight: '100dvh',
  overflow: 'hidden',
};

export default function LandingPage() {
  useEffect(() => {
    document.title = 'MecSync — Gestão Inteligente para Oficinas';
  }, []);

  const landingSrc = `/landing.html${window.location.search || ''}${window.location.hash || ''}`;

 return (
  <div style={pageStyle}>
    <iframe
      title="MecSync — Gestão Inteligente para Oficinas"
      src={landingSrc}
      style={landingFrameStyle}
    />
  </div>
);
}
